import { c as _c } from "react/compiler-runtime";
import { PASSWORD_RULES, type PasswordRuleText } from '@src/constants/PasswordSchema';
import { useLocale } from '@src/i18n/LocaleProvider';
export function usePasswordRuleText() {
  const $ = _c(2);
  const {
    t
  } = useLocale("set-password-form");
  let t0;
  if ($[0] !== t) {
    t0 = Object.fromEntries(PASSWORD_RULES.map(t1 => {
      const {
        key
      } = t1;
      return [key, t(key)];
    }));
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0 as PasswordRuleText;
}